(() => {
  const REASON_ALIASES = {
    'product-help': 'Product selection',
    'product-selection': 'Product selection',
    'order-help': 'Existing order',
    'existing-order': 'Existing order',
    order: 'Existing order',
    quote: 'Quote or project',
    project: 'Quote or project',
    'quote-or-project': 'Quote or project',
    'document-request': 'Document request',
    document: 'Document request',
    trade: 'Trade account',
    'trade-account': 'Trade account',
    general: 'Other',
    other: 'Other',
  };

  const ENTRY_TOPICS = {
    delivery: { topic: 'topicDelivery', guidance: 'routingDelivery' },
    return: { topic: 'topicReturn', guidance: 'routingReturn' },
    accessibility: { topic: 'topicAccessibility', guidance: 'routingAccessibility' },
  };

  function setIfEmpty(input, value) {
    if (!input || input.value || !value) return;
    input.value = value;
  }

  function setRequirement(input, required, optionalMarker, requiredMarker) {
    if (!input) return;
    input.required = required;
    input.setAttribute('aria-required', String(required));
    if (optionalMarker) optionalMarker.hidden = required;
    if (requiredMarker) requiredMarker.hidden = !required;
  }

  function updateRouting(form) {
    const reason = form.querySelector('[data-contact-reason]');
    const component = form.closest('.contact-form');
    const rules = {
      'Product selection': {
        productRequired: true,
        message: component?.dataset.routingProduct,
      },
      'Existing order': {
        referenceRequired: true,
        message: component?.dataset.routingOrder,
      },
      'Quote or project': {
        message: component?.dataset.routingQuote,
      },
      'Document request': {
        referenceRequired: true,
        message: component?.dataset.routingDocument,
      },
      'Trade account': {
        message: component?.dataset.routingTrade,
      },
      Other: {
        message: component?.dataset.routingOther,
      },
    };
    const rule = rules[reason?.value] || {
      message: component?.dataset.routingDefault,
    };
    const reference = form.querySelector('[data-contact-reference]');
    const product = form.querySelector('[data-contact-product]');

    setRequirement(
      reference,
      Boolean(rule.referenceRequired),
      form.querySelector('[data-contact-reference-optional]'),
      form.querySelector('[data-contact-reference-required]')
    );
    setRequirement(
      product,
      Boolean(rule.productRequired),
      form.querySelector('[data-contact-product-optional]'),
      form.querySelector('[data-contact-product-required]')
    );

    const guidance = form.querySelector('[data-contact-routing]');
    const entry = ENTRY_TOPICS[form.dataset.entryTopic];
    if (guidance) guidance.textContent = entry && reason?.value === 'Other' ? component?.dataset[entry.guidance] || rule.message : rule.message;
  }

  function initialiseContactForms(root = document) {
    const params = new URL(window.location.href).searchParams;
    const requestedReason = (params.get('reason') || '').trim();
    const requestedReference = (params.get('reference') || params.get('sku') || '').trim();
    const requestedProduct = (params.get('product') || '').trim();

    root.querySelectorAll('.contact-form__form:not([data-context-ready])').forEach((form) => {
      form.dataset.contextReady = 'true';

      const reason = form.querySelector('[data-contact-reason]');
      if (reason && requestedReason && !reason.value) {
        const normalisedReason = requestedReason.toLocaleLowerCase().replace(/\s+/g, '-');
        const entry = ENTRY_TOPICS[normalisedReason];
        const targetValue = entry ? 'Other' : REASON_ALIASES[normalisedReason] || requestedReason;
        const matchingOption = Array.from(reason.options).find(
          (option) => option.value.toLocaleLowerCase() === targetValue.toLocaleLowerCase()
        );
        if (matchingOption) reason.value = matchingOption.value;
        if (entry && matchingOption) {
          form.dataset.entryTopic = normalisedReason;
          const topic = form.querySelector('[data-contact-entry-topic]');
          const component = form.closest('.contact-form');
          if (topic) {
            topic.value = component?.dataset[entry.topic] || normalisedReason;
            topic.disabled = false;
          }
        }
      }

      setIfEmpty(form.querySelector('[data-contact-reference]'), requestedReference);
      setIfEmpty(form.querySelector('[data-contact-product]'), requestedProduct);
      reason?.addEventListener('change', () => {
        delete form.dataset.entryTopic;
        const topic = form.querySelector('[data-contact-entry-topic]');
        if (topic) {
          topic.value = '';
          topic.disabled = true;
        }
        updateRouting(form);
      });
      updateRouting(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseContactForms(), { once: true });
  } else {
    initialiseContactForms();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseContactForms(event.target));
})();
